import ItemCard from "@affinity/components/ItemCard/ItemCard";
import SetAddress from "@affinity/Handlers/SetAddress";
import { CustomState } from "@affinity/Store/Reducers";
import { combineAddress } from "@affinity/Widgets/CreateAccount/Step2Addresses";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import Button from "@insite/mobius/Button";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

type AddressCardProps = { address: ShipToModel; onAddressSelect?: (value: ShipToModel) => void };

export const AddressCard = ({ address, onAddressSelect }: AddressCardProps) => {
    const currentAccount = useSelector((state: CustomState) => state.affinity_create_account.billTo);
    const dispach = useDispatch();

    const selectAddress = React.useCallback(() => {
        if (onAddressSelect) {
            onAddressSelect(address);
            return;
        }
        if (currentAccount) {
            dispach(
                SetAddress({
                    shipTo: address,
                }),
            );
        }
    }, [currentAccount, address, onAddressSelect]);

    return (
        <ItemCard.Container key={address.id.toString()}>
            {address.customerName && <ItemCard.Title>{address.customerName}</ItemCard.Title>}
            <ItemCard.Text>{combineAddress(address)}</ItemCard.Text>
            <Button variant="secondary" sizeVariant="medium" onClick={() => selectAddress()}>
                Select
            </Button>
        </ItemCard.Container>
    );
};
